module.exports = __webpack_public_path__ + "static/media/092.d3188f3e.jpg";